/**
 * Created by Ivan on 10.08.2026
 */

Reward.register("stickers2", {
    countable: true,
    flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,

    getIcon: function () {
        return bundles.reward_icons.frames.stickers2_png;
    },

    getPrice: function (value) {
        const pack = VirtualProducts.stickers2_2;
        return pack.price / pack.reward.stickers2 * value;
    },

    parse: function (value, options) {
        if (cleverapps.stickersBook2.isAvailable() && cleverapps.stickersBook2.getAvailableCollections().length) {
            return new Reward("stickers2", value, options);
        }
        return [];
    },

    receive: function (value, options) {
        cleverapps.stickersBook2.givePrize(value, options && options.event);

        return function () {};
    }
});

Object.keys(StickersBook2.PACKS).forEach((type) => {
    const pack = StickersBook2.PACKS[type];

    Reward.register(type, {
        countable: true,
        target: "stickers2",
        flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,

        getIcon: function () {
            return bundles.reward_icons.frames[pack.icon];
        },

        getPrice: function (value) {
            return RewardTypes.stickers2.getPrice(pack.amount * value);
        },

        parse: function (value, options) {
            if (cleverapps.stickersBook2.isAvailable() && cleverapps.stickersBook2.getAvailableCollections().length) {
                return new Reward(type, value, options);
            }
            return [];
        },

        receive: function (value, options) {
            cleverapps.stickersBook2.givePrize(pack.amount * value, options && options.event, pack);

            return function () {};
        }
    });
});
